import { Component, ElementRef, ViewChild } from "@angular/core";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { CombustibleService } from "../../../../shared/services/combustible.service";
import { TanqueoService } from "../../../../shared/services/tanqueo.service";
import { FormaPagoService } from "../../../../shared/services/forma_pago.service";
import { EmpresasService } from "../../../../shared/services/empresas.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "../../../../shared/services/municipios.service";
import { Administracion } from "src/app/shared/model/administracion.model";
import { DigitalesService } from "src/app/shared/services/digitales.service";
import { AdministracionService } from "src/app/shared/services/administracion.services";
import { HttpEventType } from "@angular/common/http";
declare var require;
const Swal = require("sweetalert2");

export function noEspaciosEnBlanco(): ValidatorFn {
  return (control: AbstractControl) => {
    const valor = control.value;
    if (typeof valor === "string" && valor.trim() === "") {
      return { espaciosBlancos: true };
    }
    return null;
  };
}

@Component({
  selector: "app-combustible",
  templateUrl: "./combustible.component.html",
  styleUrls: ["./combustible.component.scss"],
})
export class CombustibleComponent {
  @ViewChild("inputNit") inputNit!: ElementRef;
  @ViewChild("inputNombre") inputNombre!: ElementRef;
  @ViewChild("inputCodigo") inputCodigo!: ElementRef;
  @ViewChild("inputDireccion") inputDireccion!: ElementRef;
  @ViewChild("inputCiudad") inputCiudad!: ElementRef;
  @ViewChild("inputCelular") inputCelular!: ElementRef;
  @ViewChild("inputEmail") inputEmail!: ElementRef;

  respuestaVehiculos: any;
  vehiculos: any[] = [];
  formNuevo: FormGroup;
  vehiculoSeleccionado: any = null;
  TipoMantenimiento: any;
  editMode: boolean;
  maxDate: string;
  combustibles: any;
  formTanqueo: FormGroup;
  tanqueoSeleccionado: any;
  tanqueos: any[];
  validate: boolean;
  totalFormateado: string = "";
  formapago: any;
  empresaselecionada: any;
  formEmpresa: FormGroup;
  modalEmpresaRef: NgbModalRef;
  administraciones: Administracion[] = [];
  empresaEds: any;
  municipios: any;

  constructor(
    private vehiclesService: VehiclesService,
    private combustibleService: CombustibleService,
    private tanqueoService: TanqueoService,
    private forma_pagoService: FormaPagoService,
    private fb: FormBuilder,
    private empresasService: EmpresasService,
    private modalService: NgbModal,
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private digitalesService: DigitalesService,
    private administracionesServices: AdministracionService
  ) {}

  ngOnInit() {
    this.cargarDataAdmin();
    this.cargarVehiculos();
    this.cargarCombustible();
    this.cargarForma_pago();
    this.cargarTaller();
    this.cargarMunicipios();

    this.formTanqueo = this.fb.group({
      placa: [null],
      fecha: [null],
      combustible: [null],
      galones: [null, [Validators.required, noEspaciosEnBlanco()]],
      valor: [null, [Validators.required, noEspaciosEnBlanco()]],
      total: [null],
      eds: [null],
      factura: [null],
      forma: [null],
      km: [null],
      observaciones: [null],
    });

    this.formEmpresa = this.fb.group({
      nit: [""],
      digito: [null],
      nombre: [null],
      direccion: [null],
      ciudad: [null],
      telefono: ["", [Validators.pattern(/^[0-9]{10}$/)]],
      celular: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      email: [null],
      observaciones: [null],
      eps: [false],
      arl: [false],
      afp: [false],
      ces: [false],
      ccf: [false],
      bancos: [false],
      transporte: [false],
      colegio: [false],
      cda: [false],
      taller: [false],
      eds: [false],
      contratista: [false],
      proveedor: [false],
      aseguradora: [false],
      almacen: [false],
      serviteca: [false],
      estado: [1],
    });

    this.formTanqueo
      .get("galones")
      ?.valueChanges.subscribe(() => this.calcularTotal());
    this.formTanqueo
      .get("valor")
      ?.valueChanges.subscribe(() => this.calcularTotal());

    const formatter = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const parts = formatter.formatToParts(new Date());
    const year = parts.find((p) => p.type === "year")?.value;
    const month = parts.find((p) => p.type === "month")?.value;
    const day = parts.find((p) => p.type === "day")?.value;

    this.maxDate = `${year}-${month}-${day}`;
    this.formTanqueo
      .get("placa")
      ?.valueChanges.subscribe((placaSeleccionada: string) => {
        const vehiculo = this.vehiculos.find(
          (v) => v.placa === placaSeleccionada
        );
        if (vehiculo) {
          this.formTanqueo.patchValue({
            combustible: vehiculo.combustible,
          });
        } else {
          this.formTanqueo.patchValue({ combustible: null });
        }
      });
  }

  private cargarVehiculos(): void {
    this.vehiclesService.getPlacasAll().subscribe({
      next: (data) => (this.vehiculos = data),
      error: (error) => console.error("❌ Error al obtener vehículos:", error),
    });
  }

  private cargarCombustible(): void {
    this.combustibleService.getAllCombustibles().subscribe({
      next: (data) => (this.combustibles = data),
      error: (error) =>
        console.error("❌ Error al obtener combustibles:", error),
    });
  }

  private cargarForma_pago(): void {
    this.forma_pagoService.getFormasPago().subscribe({
      next: (data) => (this.formapago = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarTaller(): void {
    this.empresasService.getEDS().subscribe({
      next: (data) => (this.empresaEds = data),
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => (this.municipios = data),
    });
  }

  guardarTanqueo(): void {
    this.validate = true;
    const datos = { ...this.formTanqueo.value };

    const camposObligatorios = [
      { campo: "placa", mensaje: "Por favor, selecciona una placa" },
      { campo: "fecha", mensaje: "Por favor, ingresa la fecha del tanqueo" },
      { campo: "eds", mensaje: "Selecciona la estación de servicio" },
      { campo: "km", mensaje: "Ingresa el kilometraje actual" },
      { campo: "combustible", mensaje: "Selecciona el tipo de combustible" },
      { campo: "galones", mensaje: "Ingresa la cantidad de galones" },
      { campo: "valor", mensaje: "Ingresa el valor por galón" },
      { campo: "factura", mensaje: "Ingresa el numero de factura" },
      { campo: "forma", mensaje: "Ingresa la forma de pago" },
    ];

    for (const { campo, mensaje } of camposObligatorios) {
      if (!this.formTanqueo.get(campo)?.value) {
        this.mostrarAlerta("Campo requerido", mensaje, "info");
        return;
      }
    }

    datos.total = datos.total || datos.galones * datos.valor;
    datos.estado = 1;

    this.formTanqueo.patchValue({ total: datos.total });

    this.tanqueoService.create(datos).subscribe({
      next: (tanqueoCreado) => {

        //ACTUALIZA LA LISTA DESPUES DE GUARDAR EL TANQUEO
        this.tanqueoService.getAll().subscribe({
          next: (data) => {
            this.tanqueos = data;
            this.tanqueoSeleccionado = tanqueoCreado.id;
               if (tanqueoCreado.id){
                  Swal.fire("Éxito", "Tanqueo registrado correctamente", "success");
                    this.formTanqueo.reset(); // ✅ Limpia el formulario
                    this.totalFormateado = ""; // ✅ Limpia el campo visual
               
                  const basePath =
                    this.administraciones[0].nit.toString() + "/combustibles/" +  tanqueoCreado.placa + "/" + tanqueoCreado.id;

                  let totalDropzones = this.dropzones.length;
                  let completed = 0;
                        this.dropzones.forEach((dz) => {
                          if (dz.files && dz.files.length > 0) {
                            const folder =
                              dz.type === "pdf" ? `${basePath}/factura` : `${basePath}/imagenes`;
                  
                            this.digitalesService.uploadMultiple(dz.files, folder).subscribe({
                              next: (event) => {
                                if (event.type === HttpEventType.Response) {
                               //   console.log(`✅ Dropzone ${dz.id} subida con éxito`, event.body);
                                  completed++;
                  
                                  if (completed === totalDropzones) {
                                    console.log("🎉 Todas las subidas han terminado");
                                    // 🔹 Resetear todos los dropzones
                                    this.dropzones.forEach(dz => {
                                      dz.files = [];
                                    });
                                   
                                  }
                                }
                              },
                              error: (err) => {
                                console.error(`❌ Error en dropzone ${dz.id}`, err);
                                completed++;
                                if (completed === totalDropzones) {
                                  console.log("⚠️ Subidas finalizadas con errores");
                                }
                              },
                            });
                  
                  
                          } else {
                            // Si no hay archivos en este dropzone, lo consideramos como completado
                            totalDropzones--;
                          }
                        });

              }
                

          },
          error: (err) => {
            console.error("Error al actualizar lista de tanqueos:", err);
          },
        });

     
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar el tanqueo", "error");
      },
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  dropzones = [
    {
      id: 1,
      files: [],
      error: null,
      eliminado: false,
      type: "pdf",
    },
  ];

  allowedImageTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
  maxImages = 10;

  onFileChange(event: any, dropzoneId: number): void {
    const files: FileList = event.target.files;
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (!dropzone || !files.length) return;

    dropzone.error = null;

    const validFiles: File[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.type === "application/pdf") {
        file["preview"] = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(file)
        );
        validFiles.push(file);
      } else if (this.allowedImageTypes.includes(file.type)) {
        file["preview"] = URL.createObjectURL(file);
        validFiles.push(file);
      } else {
        dropzone.error =
          "Solo se permiten archivos PDF e imágenes PNG, JPG, JPEG, etc.";
        return;
      }
    }

    // Validar cantidad
    if (
      dropzone.type === "pdf" &&
      dropzone.files.length + validFiles.length > 1
    ) {
      dropzone.error = "Solo se permite un archivo SOPORTE.";
      return;
    }

    if (
      dropzone.type === "image" &&
      dropzone.files.length + validFiles.length > this.maxImages
    ) {
      dropzone.error = `Máximo ${this.maxImages} imágenes permitidas.`;
      return;
    }

    dropzone.files = [...dropzone.files, ...validFiles];
    event.target.value = "";

    // Actualiza el campo documento con los nombres
    const allFiles = this.dropzones.flatMap((dz) => dz.files);
    this.formTanqueo.patchValue({
      documento: allFiles.map((f) => f.name).join(", "),
    });
  }

  removeFile(dropzoneId: number, index: number): void {
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (dropzone) {
      dropzone.files.splice(index, 1);
      dropzone.error = null;

      const input = document.getElementById(
        "fileInput" + dropzoneId
      ) as HTMLInputElement;
      if (input) {
        input.value = "";
        input.blur();
      }

      dropzone.eliminado = true;
      setTimeout(() => {
        dropzone.eliminado = false;
      }, 3000);
    }
  }

  limpiarDropzone(dropzoneId: number): void {
    const dropzone = this.dropzones.find((d) => d.id === dropzoneId);
    if (dropzone) {
      dropzone.files = [];
      dropzone.error = null;
      const input = document.getElementById(
        "fileInput" + dropzoneId
      ) as HTMLInputElement;
      if (input) {
        input.value = "";
        input.blur();
      }
      dropzone.eliminado = true;
      setTimeout(() => {
        dropzone.eliminado = false;
      }, 3000);
    }
  }

  abrirInput(dropzoneId: number): void {
    const input = document.getElementById(
      "fileInput" + dropzoneId
    ) as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  calcularTotal(): void {
    const galones = Number(this.formTanqueo.get("galones")?.value);
    const valor = Number(this.formTanqueo.get("valor")?.value);

    if (!galones || !valor || isNaN(galones) || isNaN(valor)) {
      this.formTanqueo.get("total")?.setValue(null, { emitEvent: false });
      this.totalFormateado = ""; // 👈 limpia el valor mostrado
      return;
    }

    const total = galones * valor;

    this.formTanqueo.patchValue({ total }, { emitEvent: false });

    this.totalFormateado = `$ ${Math.round(total).toLocaleString("es-CO")}`;
  }

  openModalEmpresa(content: any, empresa?: any): void {
    if (empresa) {
      this.editMode = true;
      this.empresaselecionada = empresa;
      this.formEmpresa.patchValue(empresa); // Carga datos en el formulario para editar
    } else {
      this.editMode = false;
      this.formEmpresa.reset(); // Limpia el formulario para un nuevo registro
    }

    const modalRef = this.modalService.open(content, {
      size: "xl",
      backdrop: "static",
      windowClass: "custom-modal-full-width",
    });

    this.modalEmpresaRef = modalRef;
  }

  guardarEmpresa(modalRef: NgbModalRef): void {
    this.validate = true;
    const datos = { ...this.formEmpresa.value };

    // Validación de correo
    const email = datos.email;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      this.mostrarAlerta(
        "Email inválido",
        "Correo no válido. Ej: usuario@dominio.com",
        "info"
      );
      return;
    }

    // Validar campos obligatorios con mensajes personalizados
    const camposObligatorios: {
      campo: string;
      mensaje: string;
      ref?: ElementRef;
    }[] = [
      {
        campo: "nit",
        mensaje: "Por favor, ingresa un número de documento",
        ref: this.inputNit,
      },
      {
        campo: "digito",
        mensaje: "Por favor, ingresa un dígito de verificación",
        ref: this.inputCodigo,
      },
      {
        campo: "nombre",
        mensaje: "Por favor, ingresa un nombre",
        ref: this.inputNombre,
      },
      {
        campo: "direccion",
        mensaje: "Por favor, ingresa una dirección",
        ref: this.inputDireccion,
      },
      {
        campo: "ciudad",
        mensaje: "Por favor, ingresa una ciudad",
        ref: this.inputCiudad,
      },
      {
        campo: "celular",
        mensaje: "Por favor, ingresa un número de celular",
        ref: this.inputCelular,
      },
      {
        campo: "email",
        mensaje: "Por favor, ingresa un correo electrónico",
        ref: this.inputEmail,
      },
    ];

   for (const { campo, mensaje, ref } of camposObligatorios) {
      const valor = this.formEmpresa.get(campo)?.value;
      
      // Para el campo digito, aceptar 0 como válido
      if (campo === 'digito') {
        if (valor === null || valor === undefined || valor === '') {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      } else {
        if (!valor) {
          this.mostrarAlerta("Campo requerido", mensaje, "info");
          ref?.nativeElement.focus();
          return;
        }
      }
    }

    // Convertir checkboxes a 1/0
    const checkboxKeys = [
      "eps",
      "arl",
      "afp",
      "ces",
      "ccf",
      "bancos",
      "transporte",
      "colegio",
      "cda",
      "taller",
      "eds",
      "contratista",
      "proveedor",
      "aseguradora",
      "almacen",
      "serviteca",
    ];
     checkboxKeys.forEach((k) => {
      //EDS 1
      if (k === 'eds' ) {
        datos[k] = 1;
      } else {
        datos[k] = datos[k] ? 1 : 0;
      }
    });

    datos.estado = 1; // Activar empresa al guardar
    datos.eds = 1; // Marcar como contratista
    this.empresasService.createEmpresa(datos).subscribe({
      next: (empresaCreada) => {
        modalRef.close();

        // 🔁 Recargar lista de talleres para incluir el nuevo
        this.cargarTaller();

        // Opcional: seleccionar automáticamente el taller recién creado
        this.formEmpresa.patchValue({ taller: empresaCreada.nombre });

        Swal.fire("Éxito", "Empresa registrada correctamente", "success");
      },
      error: () => {
        Swal.fire("Error", "No se pudo registrar la empresa", "error");
      },
    });
  }

  soloNumeros(event: KeyboardEvent): void {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  limitarLongitud(event: Event, max: number) {
  const input = event.target as HTMLInputElement;
  if (input.value.length > max) {
    input.value = input.value.slice(0, max);
    // Actualiza el FormControl asociado
    const controlName = input.getAttribute('formControlName');
    if (controlName) {
      this.formEmpresa.get(controlName)?.setValue(input.value);
    }
  }
}

private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
       // console.log(data);
          this.administraciones = data;               
        
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }


}